import script from "./WebSocketLoadingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WebSocketLoadingModal.vue?vue&type=script&setup=true&lang=js"

import "./WebSocketLoadingModal.vue?vue&type=style&index=0&id=4154a43a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4154a43a"]])

export default __exports__